import { getAppConfig, type BaseAppConfig } from "../common/config/appConfig";
import {
  mergeSchemas,
  type ConfigSchema,
} from "../common/config/validateAppConfig";
import baseSchema from "../common/config/base-app-config.schema.json";
import appSchema from "./app-config.schema.json";

export interface AppConfig extends BaseAppConfig {
  tenant: string;
  theme: string;
  signalRHubUrl: string;
  googleTagId: string | null;
  faviconUrl: string;
  faviconLightUrl: string;
  applicationLogoUrl: string;
  applicationTextLogoUrl: string;
  authLogoAdditionalClass: boolean;
}

export const appConfigSchema: ConfigSchema = mergeSchemas(
  baseSchema as ConfigSchema,
  appSchema as ConfigSchema
);

const appConfig = () => getAppConfig<AppConfig>();
export default appConfig;
